import React from 'react'
import { ShimmerBlock, StatCardSkeleton } from "../common/Skeleton";

export { StatCardSkeleton };

const EmployeeTableRowSkeleton: React.FC = () => (
  <div className="grid grid-cols-12 gap-4 py-3 px-6 border-b border-border-tertiary last:border-b-0">
    <div className="col-span-2 flex items-center space-x-3">
      <ShimmerBlock className="w-10 h-10 rounded-full" />
      <div>
        <ShimmerBlock className="h-4 w-28 mb-1" />
        <ShimmerBlock className="h-3 w-16" />
      </div>
    </div>

    <div className="col-span-2 flex items-center">
      <ShimmerBlock className="h-4 w-20" />
    </div>
    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-4 w-16" />
    </div>
    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-4 w-24" />
    </div>
    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-4 w-20" />
    </div>

    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-4 w-16" />
    </div>
    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-4 w-12" />
    </div>

    <div className="col-span-1 flex flex-col justify-center">
      <ShimmerBlock className="h-4 w-16 mb-1" />
      <ShimmerBlock className="h-3 w-12" />
    </div>

    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-4 w-16" />
    </div>

    <div className="col-span-1 flex items-center">
      <ShimmerBlock className="h-5 w-16 rounded-full" />
    </div>

    <div className="col-span-1 flex items-center space-x-2 justify-center">
      <ShimmerBlock className="w-4 h-4 rounded-full" />
      <ShimmerBlock className="w-4 h-4 rounded-full" />
      <ShimmerBlock className="w-4 h-4 rounded-full" />
    </div>
  </div>
);

export const EmployeeTableSectionSkeleton: React.FC = () => {
  const skeletonRows = Array.from({ length: 4 });

  return (
    <div className="bg-surface rounded-card shadow-soft border border-border-secondary overflow-auto">
      
      <div className="px-6 py-4 border-b border-border-secondary">
        <ShimmerBlock className="h-6 w-48" />
      </div>

      <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 border-b border-border-tertiary bg-layout-hover">
          <div className="col-span-2"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-2"><ShimmerBlock className="h-4 w-12" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
          <div className="col-span-1"><ShimmerBlock className="h-4 w-16" /></div>
      </div>
      
      <div className="divide-y divide-border-tertiary">
        {skeletonRows.map((_, index) => (
          <EmployeeTableRowSkeleton key={index} />
        ))}
      </div>

      {/* Pagination Skeleton (mimic the footer) */}
      <div className="px-6 py-4 flex justify-between items-center border-t border-border-secondary">
        <ShimmerBlock className="h-6 w-24" />
        <div className="flex space-x-4">
            <ShimmerBlock className="h-6 w-16 rounded" />
            <ShimmerBlock className="h-6 w-32 rounded" />
        </div>
      </div>
    </div>
  );
};